import React from "react";
import { Container, Breadcrumb } from "react-bootstrap";
// import "./AboutBreadcrumb.css";

const CoureseDetailsBreadcrumb = () => {
    return (
        <div className="about-breadcrumb-section ">
            <Container className="heading-title">
                <h2 className="about-title text-center">
                    Course Details
                    {/* <span className=" about-text">Us</span> */}
                </h2>
                <Breadcrumb>
                    <Breadcrumb.Item href="#">Home</Breadcrumb.Item>
                    <Breadcrumb.Item active className="about-text">Courses</Breadcrumb.Item>
                    <Breadcrumb.Item href="#">Course Details Page</Breadcrumb.Item>
                </Breadcrumb>
            </Container>
        </div>
    );
};

export default CoureseDetailsBreadcrumb;
